import { css } from '@linaria/core';
export const pulseAnimation = `
	@keyframes pulse {
		0% {
			opacity: 1;
		}

		50% {
			opacity: 0.5;
		}

		100% {
			opacity: 1;
		}
	}

	animation: pulse 1s 0.2s var(--global-ease-in-out) infinite;
`;
export const Placeholder = {
    base: css `
		display: block;

		box-sizing: border-box;
		width: 100%;
		height: 1.8rem;
		padding: 0.4rem 0;

		&:after {
			${pulseAnimation};
			content: '';

			display: block;

			width: 100%;
			height: 100%;
			border-radius: 24px;

			background-color: rgb(var(--teaser-color-base-background-loading-alpha));
		}
	`,
    alignment: {
        left: null,
        center: css `
			margin: 0 auto !important;
		`,
        right: css `
			float: right;
		`,
    },
};
export const ChildPlaceholder = {
    base: css `
		&:after {
			${pulseAnimation};
			opacity: 1;
		}
	`,
};
